export default __webpack_public_path__ + "static/media/potato.813dd118.jpg";